import React from 'react';
import { Bell, Building2, Globe, Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useFiliale } from '../context/FilialeContext';
import { ROLE_LABELS } from '../data/filiales';
import BlueHeader from '../components/BlueHeader';

const Settings = () => {
  const { user } = useAuth();
  const { currentFiliale, canSwitch, isConsolidated } = useFiliale();

  return (
    <div>
      <BlueHeader
        title="Paramètres"
        subtitle="Compte et configuration"
        showBack={false}
      />

      <div className="p-6">
        <h3 className="mb-4 text-sm font-semibold text-night-blue">Mon profil</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-medium">Nom</label>
            <input type="text" value={user?.nom || ''} className="input-field" disabled />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-medium">Prénom</label>
            <input type="text" value={user?.prenom || ''} className="input-field" disabled />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-medium">Email</label>
            <input type="email" value={user?.email || ''} className="input-field" disabled />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-medium">Rôle</label>
            <input type="text" value={ROLE_LABELS[user?.role] || user?.role || ''} className="input-field" disabled />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-medium">Filiale d’affectation</label>
            <input
              type="text"
              value={canSwitch ? 'Accès groupe' : (currentFiliale?.libelle || 'Non assignée')}
              className="input-field"
              disabled
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-medium">Périmètre courant</label>
            <input
              type="text"
              value={isConsolidated ? 'Toutes les filiales' : (currentFiliale?.libelle || '—')}
              className="input-field"
              disabled
            />
          </div>
        </div>
      </div>

      {user?.role === 'super_admin' && (
        <div className="card mb-4">
          <h3 className="mb-4 text-sm font-semibold text-night-blue">Plateforme</h3>
          <div className="space-y-3">
            {[
              { icon: Building2, title: 'Gestion des filiales', text: 'Ajouter ou modifier les entités du groupe' },
              { icon: Globe, title: 'Règles multi-filiales', text: 'Périmètre, devises et accès' },
              { icon: Lock, title: 'Sécurité', text: 'Mots de passe et sessions' },
              { icon: Bell, title: 'Notifications', text: 'Alertes internes' },
            ].map((item) => (
              <div key={item.title} className="flex flex-col gap-3 rounded-md bg-slate-50 p-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center gap-3">
                  <item.icon className="h-4 w-4 text-sky-blue-dark" />
                  <div>
                    <p className="font-medium text-night-blue">{item.title}</p>
                    <p className="text-sm text-gray-medium">{item.text}</p>
                  </div>
                </div>
                <button type="button" className="btn-secondary">Ouvrir</button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="card">
        <h3 className="mb-4 text-sm font-semibold text-night-blue">Système</h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between"><span className="text-gray-medium">Version</span><span className="font-medium">1.0.0</span></div>
          <div className="flex justify-between"><span className="text-gray-medium">Architecture</span><span className="font-medium">Console admin multi-filiales</span></div>
          <div className="flex justify-between"><span className="text-gray-medium">Encodage</span><span className="font-medium">UTF-8 (utf8mb4)</span></div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
